// @flow
import { flatMap, get } from 'lodash/fp';

import createReducer from '../utils/createReducer';
import { API_CALL_SUCCESS, API_CALL_FAILURE, API_CALL_REQUEST } from '../constants/actionTypes';
import { RAPIDFIRE_UPCOMING, CHALLENGE } from '../constants/apiTypes';
import decodeRapidfireChallenge from '../normalizers/decodeRapidfireChallenge';

const initialState = {
  activeSports: [],
  hasInitialised: false,
  isLoading: false,
  payStructures: [],
  upcomingChallenges: []
};

const rapidfireReducer = createReducer(initialState, {
  [API_CALL_REQUEST]: (state, { api }) => {
    if (api === RAPIDFIRE_UPCOMING) {
      return {
        isLoading: true
      };
    }
    return {};
  },
  [API_CALL_SUCCESS]: (state, { data = [], meta = {}, api }) => {
    switch (api) {
      case RAPIDFIRE_UPCOMING:
        return {
          activeSports: flatMap('sports')(data),
          competitions: get('competitions', meta) || [],
          hasInitialised: true,
          isLoading: false,
          upcomingChallenges: data.map(ch => decodeRapidfireChallenge(ch, meta))
        };
      case CHALLENGE:
        return {
          payStructures: get('rapidfire_challenge.pay_structures', data)
        };
      default:
        return {};
    }
  },
  [API_CALL_FAILURE]: (state, { api }) => {
    if (api === RAPIDFIRE_UPCOMING) {
      return {
        isLoading: false
      };
    }
    return {};
  }
});

export default rapidfireReducer;
